import React from "react";
import LogoMohme from "../img/logofgml.png";
import LogoPropuesta from "../img/gpc-original.png";

const Footer = () => {
  return (
    <footer className="bg-light">
      <div className="container">
        <div className="creditos text-center">
          <p>Programa de apoyo a Investigaciones periodísticas en regiones ejecutado por el Grupo Propuesta Ciudadana en alianza con la Fundación Gustavo Mohme Llona, en el marco del proyecto "Construyendo mejores prácticas de gobernanza del sector extractivo en Perú EITI".</p>
          <br></br>
          <p><strong>Coordinación periodística:</strong> Wilber Huacasi</p>
          <p><strong>Desarrollo web:</strong> Melissa Chávez</p>
          <p><strong>Asistencia periodística:</strong> Edmundo Cruz y Jacqueline Fowks</p>
          <p><strong>Asesoría técnica:</strong> Grupo Propuesta Ciudadana</p>
          <br></br>
          <p><strong>Año 2020</strong></p>
        </div>
        <div className="logos d-flex flex-column flex-md-row justify-content-center align-items-center text-center">

          <a href="https://propuestaciudadana.org.pe/">
            <img src={LogoPropuesta} alt="Grupo Propuesta Ciudadana" />
          </a>

          <a href="https://fundacionmohme.org">
            <img src={LogoMohme} alt="Fundación Gustavo Mohme Llona" />
          </a>

        </div>
       
      </div>
    </footer>
  );
};

export default Footer;
